import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const MapPinIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/map-pin"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M11.6281 22.72L11.6314 22.7215C11.868 22.8244 12 22.8004 12 22.8004C12 22.8004 12.132 22.8244 12.3695 22.721L12.3719 22.72L12.3788 22.7168L12.4005 22.7068C12.4186 22.6984 12.4436 22.6867 12.4751 22.6715C12.538 22.6411 12.627 22.5971 12.7384 22.539C12.9609 22.423 13.2734 22.2506 13.646 22.0197C14.3895 21.559 15.3808 20.8595 16.3746 19.9017C18.3626 17.9855 20.4 14.9914 20.4 10.8004C20.4 6.1612 16.6392 2.40039 12 2.40039C7.36078 2.40039 3.59998 6.1612 3.59998 10.8004C3.59998 14.9914 5.63737 17.9855 7.6254 19.9017C8.61914 20.8595 9.6105 21.559 10.354 22.0197C10.7265 22.2506 11.039 22.423 11.2616 22.539C11.3729 22.5971 11.4619 22.6411 11.5249 22.6715C11.5564 22.6867 11.5814 22.6984 11.5994 22.7068L11.6212 22.7168L11.6281 22.72ZM12 13.5004C13.4911 13.5004 14.7 12.2916 14.7 10.8004C14.7 9.30922 13.4911 8.10039 12 8.10039C10.5088 8.10039 9.29998 9.30922 9.29998 10.8004C9.29998 12.2916 10.5088 13.5004 12 13.5004Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MapPinIcon;